import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';
import { useLanguage } from '../../context/LanguageContext';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();
  const { language } = useLanguage();
  const isZh = language === 'zh';

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">{isZh ? '下一步？' : 'What’s Next?'}</h2>

      <h2 className="title">{isZh ? '与我联系' : 'Get In Touch'}</h2>

      <p>
        {isZh
          ? '我正在积极寻找自己感兴趣领域的职位，尤其是金融与 AI 相关方向。无论你是有机会想要洽谈，还是只想打个招呼，我都会尽力回复你！'
          : 'I am actively seeking positions in my areas of interest, particularly in finance and AI-related fields. Whether you have an opportunity to discuss or just want to say hi, I\'ll try my best to get back to you!'}
      </p>

      <a
        className="email-link"
        href="https://www.linkedin.com/in/junyixu/"
        target="_blank"
        rel="noopener noreferrer">
        {isZh ? '打个招呼' : 'Say Hello'}
      </a>
    </StyledContactSection>
  );
};

export default Contact;
